import { render } from "./IconBell.vue?vue&type=template&id=533e7992&ts=true"
import script from "./IconBell.vue?vue&type=script&lang=ts"
export * from "./IconBell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__